import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function ExceptionReducer(state = initialState.exception, action) {
	switch (action.type) {
		case types.THROW_EXCEPTION: {
			let body = action.body;

			if (action.body instanceof Error) {
				body = {};
				let propNames = Object.getOwnPropertyNames(action.body);
				for (let key in propNames) {
					body[propNames[key]] = action.body[propNames[key]];
				}
			}
			return Object.assign({},
				state, body);
		}
		case types.CLEAR_EXCEPTION: {
			return {};
		}
		default:
			return state;
	}
}
